import styled from 'styled-components';
import { PH } from './theme';

export const StyledAppsTab = styled.div`
  font-size: ${PH.fontSizeBase};
  line-height: ${PH.lineHeightBody};
  color: ${PH.text};

  .apps-toolbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;

    .apps-search {
      max-width: 260px;
      font-size: ${PH.fontSizeBase};
    }
  }

  .apps-loading {
    padding: 24px;
    color: ${PH.textMuted};
    font-size: ${PH.fontSizeBase};
  }

  .apps-section {
    margin-bottom: 28px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .apps-section-title {
    font-size: 15px;
    font-weight: 600;
    margin: 0 0 12px;
    color: ${PH.text};
  }

  .apps-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
    align-items: stretch;
  }

  .app-card.ant-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid ${PH.border};
    background: ${PH.surfaceMuted};
    box-shadow: none;

    &.app-card-blocked {
      opacity: 0.55;
      pointer-events: auto;
    }

    &.app-card-blocked {
      opacity: 0.55;
      pointer-events: auto;
    }

    .ant-card-body {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;
      padding: 18px;
    }
  }

  .app-card-top {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .app-card-title-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 10px;
  }

  .app-card-heading {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1 auto;
    min-width: 0;
  }

  .app-logo-wrap {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 8px;
    overflow: hidden;
    background: ${PH.surface};
    border: 1px solid ${PH.border};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .app-logo {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  .app-logo-placeholder {
    font-size: 18px;
    font-weight: 700;
    color: ${PH.textMuted};
    line-height: 1;
  }

  .app-name {
    font-weight: 700;
    font-size: ${PH.fontSizeSection};
    line-height: 24px;
    color: ${PH.text};
    letter-spacing: -0.01em;
    flex: 1 1 auto;
    min-width: 0;
  }

  .app-card-top-actions {
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;

    .ant-btn {
      font-size: 16px;
    }
  }

  .app-icon-btn {
    color: ${PH.textMuted};

    &:not(:disabled):hover {
      color: ${PH.text};
      background: rgba(0, 0, 0, 0.04);
    }
  }

  .app-delete-btn {
    color: ${PH.error};

    &:not(:disabled):hover {
      color: #a8071a;
      background: rgba(199, 50, 45, 0.08);
    }
  }

  .app-header-status-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    font-size: 16px;
    border-radius: 4px;

    &.connected {
      color: ${PH.success};
      background: ${PH.successBg};
    }
  }

  .app-description {
    font-size: ${PH.fontSizeSm};
    color: ${PH.textMuted};
    line-height: ${PH.lineHeightBody};
    margin: 0;
    flex: 1 1 auto;
  }

  .app-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    flex-shrink: 0;
    margin-top: auto;
    padding-top: 14px;
    border-top: 1px solid ${PH.border};
  }

  .app-footer-left {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    min-height: 36px;
  }

  .app-footer-right {
    flex-shrink: 0;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .app-sync-btn {
    border-color: ${PH.borderStrong};
    color: ${PH.primary};
    font-weight: 600;
    font-size: ${PH.fontSizeSm};

    &:not(:disabled):hover {
      color: ${PH.primary};
      border-color: ${PH.primary};
      background: rgba(0, 0, 0, 0.02);
    }
  }

  .app-connect-btn {
    font-weight: 600;
    font-size: ${PH.fontSizeSm};
  }

  .app-footer-status {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: ${PH.fontSizeBase};
    font-weight: 600;
    white-space: nowrap;

    &.connected {
      color: ${PH.success};
    }
  }
`;
